import { Link } from "react-router-dom";
import { Col, Row, VImage } from "../../../style/base.style";
import { breadcrumb_bg_01, breadcrumb_bg_02, breadcrumb_icon } from "../../../constants/images";

import styled from "styled-components";
import { Colors } from "../../../style/colors";

interface BreadCrumbProps {
    title: string;
}

export const BreadCrumb: React.FC<BreadCrumbProps> = ({ title }) => {
    return (
      <Container>
        <Col>
        <div className="breadcrumb-bar">
        <nav aria-label="breadcrumb" className="page-breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="isax isax-home-15" />
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">{title}</li>
                    </ol>
                    <h2 className="breadcrumb-title">{title}</h2>
                  </nav>
                  </div>

        </Col>

      

          </Container>
    );
}

const Container = styled.div`
background-color: ${Colors.lightPrimary};
background-image: url(${breadcrumb_bg_01}), url(${breadcrumb_bg_02});
background-position: left center, right center;
background-repeat: no-repeat, no-repeat;
  `